import * as React from 'react';
import { ActivitySchedule, ActivityDefinition } from '../../../model/activities';
import { NewEventComponent } from './NewEventComponent';
import { NoEventComponent } from './NoEventComponent';
import { NewEventComponentNoActivity } from './NewEventComponentNoActivity';
import { tag } from '../../../model/tag';
import { trainer } from '../../../model/trainer';

interface IProps {
    onCreate: (a: ActivitySchedule) => any;
    events: number;
    classes: any;
    sourceActivity: ActivityDefinition;
    allActivities?: ActivityDefinition[];
    allTags?: tag[];
    trainers:trainer[];
}
export const EmptyEventComponent = (props: IProps) => {
    const [createNew, setCreateNew] = React.useState(false);
    return <>
        {createNew && props.sourceActivity && <NewEventComponent trainers={props.trainers} onCreate={props.onCreate} sourceActivity={props.sourceActivity} classes={props.classes} onUndo={() => setCreateNew(false)}></NewEventComponent>}
        {createNew && !props.sourceActivity && <NewEventComponentNoActivity trainers={props.trainers} allTags={props.allTags} onCreate={props.onCreate} allActivities={props.allActivities} classes={props.classes} onUndo={() => setCreateNew(false)}></NewEventComponentNoActivity>}
        {!createNew && <NoEventComponent events={props.events} classes={props.classes} onNewEventClick={() => setCreateNew(true)}></NoEventComponent>}
    </>
}